import { render, staticRenderFns } from "./PaymentElementCallback.vue?vue&type=template&id=2f2f25cd&scoped=true&"
import script from "./PaymentElementCallback.vue?vue&type=script&lang=js&"
export * from "./PaymentElementCallback.vue?vue&type=script&lang=js&"
import style0 from "./PaymentElementCallback.vue?vue&type=style&index=0&id=2f2f25cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f25cd",
  null
  
)

export default component.exports